// extracted by mini-css-extract-plugin
export default {"thoughtProcess":"analysis-panel_thoughtProcess__nGPVx","closeBtn":"analysis-panel_closeBtn__++NzE","pdfZone":"analysis-panel_pdfZone__sToty"};